.theme-menu { position: relative; display: inline-flex; }
.theme-pop { position: absolute; top: calc(100% + 6px); right: 0; z-index: 90; display: flex; flex-direction: column; min-width: 170px; padding: 4px;
             background: var(--bg-1); border: 1px solid var(--line-2); border-radius: 7px; box-shadow: var(--shadow-pop); }
.theme-pop button { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border: 0; border-radius: 5px; background: none; color: var(--fg-1);
                    font: inherit; font-size: 13.5px; text-align: left; cursor: pointer; white-space: nowrap; }
.theme-pop button:hover { background: var(--bg-2); }
.theme-pop .tick { margin-left: auto; color: var(--accent-hi); }
/* a small swatch of each look; System is half light, half dark */
.theme-sw { width: 14px; height: 14px; flex-shrink: 0; border-radius: 4px; border: 1px solid var(--line-2); }
.theme-sw.light { background: #ffffff; }
.theme-sw.dark { background: #0a0a0a; }
.theme-sw.graphite { background: linear-gradient(135deg, #1b1f23 55%, #4fc46a 55%); }
.theme-sw.system { background: linear-gradient(135deg, #ffffff 50%, #0a0a0a 50%); }
